
import api from "./api";

const stockReturnService = {


  save: async (data) => {
    const res = await api.post("/stockReturn/save", data);
    return res.data;
  },


  // getAll: async (companyId) => {
  //   const res = await api.get(`/stockReturn/getAll/${companyId}`);
  //   return res.data;
  // },

  // getAll: async (companyId, employeeId, roleId, page, limit) => {
  //   const res = await api.get(
  //     `/stockReturn/getAll/${companyId}/${employeeId}/${roleId}`, {
  //     params: {
  //       page,
  //       limit
  //     }
  //   }
  //   );
  //   return res.data;
  // },

getAll: (
  companyId,
  employeeId,
  roleId,
  page,
  limit,
  search,
  status
) =>
  api.get(
    `/stockReturn/getAll/${companyId}/${employeeId}/${roleId}`,
    {
      params: {
        page,
        limit,
        search,
        status
      }
    }
  ),

  getById: async (id) => {
    const res = await api.get(`/stockReturn/getById/${id}`);
    return res.data;
  },


  update: async (id, data) => {
    const res = await api.put(`/stockReturn/update/${id}`, data);
    return res.data;
  },


  delete: async (id) => {
    const res = await api.delete(`/stockReturn/delete/${id}`);
    return res.data;
  },

  approve: async (id, data) => {
    const res = await api.put(`/stockReturn/approve/${id}`, data);
    return res.data;
  },


  reject: async (id, data) => {
    const res = await api.put(`/stockReturn/reject/${id}`, data);
    return res.data;
  },


  cancel: async (id, data) => {
    const res = await api.put(`/stockReturn/cancel/${id}`, data);
    return res.data;
  },


  updateStatus: async (id) => {
    const res = await api.put(`/stockReturn/toggle-status/${id}`);
    return res.data;
  },

  previewVoucherNo: (projectId, storeId) =>
    api.get(`/stockReturn/generate-voucher/${projectId}/${storeId}`),


  // // 🔹 AVAILABLE STOCK (LIVE)
  // getAvailableStock: async (companyId, projectId, storeId, itemId) => {
  //   const res = await api.get(
  //     `/stockIndent/available-stock/${companyId}/${projectId}/${storeId}/${itemId}`
  //   );
  //   return res.data.result; // { quantity, uom }
  // },

  // getAvailableStock: (companyId, projectId, storeId, itemId) =>
  // api.get(
  //   `/stockReturn
  //   /available-stock/${companyId}/${projectId}/${storeId}/${itemId}`
  // ),

  // 🔹 GET VOUCHERS BY PROJECT + STORE
  getVouchers: async (projectId, storeId, projectLocationId, excludeId = null) => {
    let url = `/stockReturn/voucher/${projectId}/${storeId}/${projectLocationId}`;
    if (excludeId) {
      url += `?excludeId=${excludeId}`;
    }
    const res = await api.get(url);
    return res.data;
  },

  // 🔹 GET ITEMS BY VOUCHER
  getItemsByVoucher: async (vocherNo, toStoreId = null, headerStoreId = null, excludeId = null) => {
    const encodedVoucher = encodeURIComponent(vocherNo);
    let url = `/stockReturn/items/${encodedVoucher}`;
    const params = [];
    if (toStoreId) params.push(`toStoreId=${toStoreId}`);
    if (headerStoreId) params.push(`headerStoreId=${headerStoreId}`);
    if (excludeId) params.push(`excludeId=${excludeId}`);
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }
    const res = await api.get(url);
    return res.data;
  },

  getAvailableQty: async (vocherNo, itemId, excludeId = null) => {
    const encodedVoucher = encodeURIComponent(vocherNo);
    let url = `/stockReturn/available/${encodedVoucher}/${itemId}`;
    if (excludeId) {
      url += `?excludeId=${excludeId}`;
    }
    const res = await api.get(url);
    return res.data;
  },






};

export default stockReturnService;
